import React, { useMemo } from 'react';
import { IconBank, IconBox, IconCoinStack, IconHome, IconMoneyBag, } from 'design-system/icons';
import { IconBankCard } from 'design-system/icons/IconBankCard';
import IconCar from 'design-system/icons/IconCar';
import IconGraph from 'design-system/icons/IconGraph';
import IconMortgage from 'design-system/icons/IconMortgage';
import { IconPiggy } from 'design-system/icons/IconPiggy';
export const DUMMY_ACCOUNT_ICON_MAP = {
    REAL_ESTATE: <IconHome gradientKey="orange"/>,
    VEHICLE: <IconCar gradientKey="turquoise"/>,
    OTHER: <IconBox gradientKey="lightPink"/>,
    CHECKING: <IconBank gradientKey="lightPurple"/>,
    CREDITCARD: <IconBankCard gradientKey="darkPurple"/>,
    SAVINGS: <IconPiggy gradientKey="deepPink"/>,
    LOAN: <IconMoneyBag gradientKey="skyBlue"/>,
    MORTGAGE: <IconMortgage gradientKey="orange"/>,
    INVESTMENT: <IconGraph gradientKey="skyBlue"/>,
    PENSION: <IconCoinStack gradientKey="apricot"/>,
};
const useDummyAccountLogo = (type, size = 35) => {
    const icon = useMemo(() => {
        const element = type && DUMMY_ACCOUNT_ICON_MAP[type] ? (DUMMY_ACCOUNT_ICON_MAP[type]) : (<IconBank gradientKey="lightPurple"/>);
        return React.isValidElement(element)
            ? React.cloneElement(element, {
                height: size,
                width: size,
            })
            : null;
    }, [size, type]);
    return icon;
};
export default useDummyAccountLogo;
